module.exports = __webpack_public_path__ + "static/img/bird.a4fc67f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/bird.png
// module id = z0kc
// module chunks = 0